/**
 * Processing page : wrapper for angular components
 */
TaskProcessWrapperController.$inject = [
  'company',
  'loggedUser',
  '$scope',
  '$stateParams',
  'PushboxFactory',
  '$rootElement',
  'TopToolbarFactory',
  '$state',
  'UserFactory'
];
export function TaskProcessWrapperController(
  company,
  loggedUser,
  $scope,
  $stateParams,
  PushboxFactory,
  $rootElement,
  TopToolbarFactory,
  $state,
  UserFactory
) {
  $scope.onTaskLoaded = onTaskLoaded;
  init();

  function onTaskLoaded(ctx) {
    $scope.angularTaskProcessContext = ctx;

    if ($scope.angularTaskProcessContext.site.id && UserFactory.isLoggedUserReadOnlyForSite($scope.angularTaskProcessContext.site.id)) {
      $rootElement.addClass('read-only-application');
    }
  }

  function initTodayCounters() {
    if (!$state.includes('**.pushbox.**')) {
      PushboxFactory.getTodayCounters(company.id).then(res =>
        TopToolbarFactory.setTppTodayCounters(res.data.answered, res.data.archived, res.data.assigned, $scope)
      );
      $scope.$on('$destroy', () => TopToolbarFactory.clearTppTodayCounters($scope));
    }
  }

  function init() {
    // For the angular-downgraded task process directive
    $scope.processedTaskId = Number($stateParams.processedTaskId);
    $scope.isPushboxMode = $state.includes('auth.alcmeon.pushbox');
    $rootElement.removeClass('alc-v3-content'); // see comment in v3-v4-css-class.run.js
    $rootElement.addClass('alc-angular-task-process-page');

    if (!UserFactory.isLoggedUserReadOnlyForAllSites()) {
      TopToolbarFactory.setTitleTranslation('m/task-process/top-toolbar-process-message', $scope);
      initTodayCounters();
    } else {
      TopToolbarFactory.clearAllConfigElement();
      TopToolbarFactory.setTitleTranslation('m/task-process/top-toolbar-process-message/read-only', $scope);
    }
  }
}
